export const kebabCaseToMacroCase = (value: string): string => value?.toUpperCase().split("-").join("_");
